import { ref } from 'vue';

export const useCopilotButton = () => {
  const isHovered = ref(false);
  const setHovered = (v: boolean) => {
    isHovered.value = v;
  };
  return { isHovered, setHovered };
};
